module.exports = __webpack_public_path__ + "static/img/The_library.1390ef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/The_library.png
// module id = 5oqm
// module chunks = 0